import { NoEmailSvg } from 'lib/images';
import React, { useEffect, useState } from 'react';
import {
  CovideoHeader,
  Description,
  EmailVerificationWrapper,
  HeaderImage,
  Heading,
  Resend,
  TextDetails,
} from './style';
import { useSendEmailVerification } from 'lib/api/emailVerification/sendEmailVerification';
import { useCheckEmailVerificationToken } from 'lib/api/emailVerification/checkEmailVerificationToken';
import { useHistory, useLocation } from 'react-router-dom';
import { useAuth } from 'lib/context';
import { LoadingIndicator } from 'lib/components';
import { useIsMutating } from 'react-query';
import { usersKeys } from 'lib/api/users/queryKeys';
import { errorToast } from 'lib/components/toasts/error';

export const EmailVerification = () => {
  const { invalidateUser } = useAuth();
  const history = useHistory();
  // get token from params
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const token = query.get('token');

  const [resent, setResent] = useState(false);

  const {
    mutateAsync: sendEmailVerification,
    isLoading: isSendingEmailVerification,
  } = useSendEmailVerification(setResent);
  const { data: checkToken, isLoading: isCheckingToken } =
    useCheckEmailVerificationToken(token ?? '', !!token);
  const isMutatingUser = useIsMutating(usersKeys.user());

  const handleSendEmailVerification = async () => {
    await sendEmailVerification();
  };

  const refreshUser = async () => {
    await invalidateUser();
    history.push(`/home`);
  };

  useEffect(() => {
    const validToken = checkToken && checkToken.valid;
    if (validToken) {
      refreshUser();
    } else if (token && !isCheckingToken) {
      errorToast({
        title:
          'Your verification token has expired. Please request a new token to continue.',
      });
    }
  }, [checkToken, token]);

  const loading = isCheckingToken || isMutatingUser > 0;

  if (loading) {
    return <LoadingIndicator isLoading={loading} />;
  }

  return (
    <>
      <CovideoHeader>
        <HeaderImage
          src='https://www.covideo.com/images/covideo-logo-dark.svg'
          alt='dark logo'
        />
      </CovideoHeader>
      <EmailVerificationWrapper>
        <TextDetails>
          <Heading>Check Your Email</Heading>
          <Description>
            Click on the link in email we have sent you to verify your account.
          </Description>
          <Resend
            onClick={handleSendEmailVerification}
            disabled={resent || isSendingEmailVerification}
          >
            Resend Email
          </Resend>
        </TextDetails>
        <NoEmailSvg />
      </EmailVerificationWrapper>
    </>
  );
};
